import { SampleProfilesReducers } from './containers/SampleProfilesTab';
import { SampleSavedSearchesReducers } from './containers/SampleSavedSearchesTab';

export default from './SamplesPage';
export const SamplesPageReducers = {
  ...SampleProfilesReducers,
  ...SampleSavedSearchesReducers,
};
